export default __webpack_public_path__ + "static/media/img_docker-colorBkg.bb690fea.png";